import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const INVENTORIES_ROUTES: RouteObject[] = [
  {
    path: 'inventory',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'apples',
        lazy: async () => {
          const InventoryApplesPage = lazy(
            () =>
              import(
                '@/pages/inventory/inventoryApples/InventoryApplesPage.tsx'
              )
          )
          return { element: <InventoryApplesPage /> }
        }
      },
      {
        path: 'automotive',
        lazy: async () => {
          const InventoryAutomotivesPage = lazy(
            () =>
              import(
                '@/pages/inventory/inventoryAutomotive/InventoryAutomotivePage'
              )
          )
          return { element: <InventoryAutomotivesPage /> }
        }
      },
      {
        path: 'products',
        lazy: async () => {
          const InventoryProductsPage = lazy(
            () =>
              import(
                '@/pages/inventory/inventoryProducts/InventoryProductsPage.tsx'
              )
          )
          return { element: <InventoryProductsPage /> }
        }
      }
    ]
  }
]

export default INVENTORIES_ROUTES
